"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("styled-components");

var palette_1 = require("./palette");

var typography_1 = require("./typography");

var breakpoints_1 = require("./breakpoints");

var spacing_1 = require("./spacing");

var z_index_1 = require("./z-index");

var border_1 = require("./border");

var transitions_1 = require("./transitions");

var shadows_1 = require("./shadows");

exports.createTheme = function (_a) {
  var paletteInput = _a.palette;
  var palette = palette_1.createPalette(paletteInput);
  return {
    palette: palette,
    breakpoints: breakpoints_1["default"],
    spacing: spacing_1["default"],
    typography: typography_1["default"],
    zIndex: z_index_1["default"],
    border: border_1["default"],
    transitions: transitions_1["default"],
    shadows: shadows_1["default"]
  };
};